import React from 'react';
// import { useSelector } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { chainId } from '../../cache';

export const attachChainId = (path, chainId, params) => {
    if (!chainId) {
        return '/notFound';
    }

    if (path.includes('chainId')) return path;

    return path + '?chainId=' + chainId + (params ? Object.keys(params).map(key => `&${key}=${params[key]}`) : '');
};

export const PIRedirect = ({ to, params, ...props }) => {
    // const chainId = useSelector(state => state.business.chain.id);

    return <Redirect to={attachChainId(to, chainId, params)} replace {...props} />;
};

export const PILink = ({ to, params, ...props }) => {
    // const chainId = useSelector(state => state.business.chain.id);

    return <Link to={attachChainId(to, chainId, params)} replace {...props} />;
};
